<template>
  <div>
    <b-card class="list-filters">
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <label for="inline-form-input-name">
                <translate>Date Range (120 days max.)</translate>
              </label>
              <label v-show="updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetupdatedDateRange"><translate>reset range</translate></a>]</label>
              <date-range-picker
                v-if="this.locale.daysOfWeek"
                v-model="updatedDateRange"
                :locale-data="locale"
                :opens="opens"
                class="mb-2 w-100"
                :ranges="ranges"
                :min-date="minDate"
                @update="updateValues"
              >
                <template #input="picker">
                  <div style="top: 3px;position:relative">
                    <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                    <span v-if="updatedDateRangeActive === 0" style="vertical-align: middle"><translate>Last 7 days</translate></span>
                    <span v-else style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L')}} - {{moment(updatedDateRange.endDate).format('L')}}</span>
                  </div>
                </template>
              </date-range-picker>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="p-0">
      <b-row>
        <b-col v-for="(total, i) in totals" :key="i" sm="6" md="3">
          <h6><b-badge :variant="total > 0 ? 'secondary' : 'dark'"><big>{{total}}</big></b-badge> <b-link target="_blank" :href="'/shippings/list?qf=' + makeLink([i])">{{ i }}</b-link></h6>
        </b-col>
        <b-col sm="6" md="3">
          <h6><b-badge :variant="workedCouriers > 0 ? 'secondary' : 'dark'"><big>{{workedCouriers}}</big></b-badge> {{couriersI18n}}</h6>
        </b-col>
        <b-col sm="6" md="3">
          <h6><b-badge :variant="generalStalled > 0 ? 'danger' : 'dark'"><big>{{generalStalled}}</big></b-badge> <b-link v-if="utcGeneralStalledDateTo" target="_blank" :href="'/shippings/list?qf=%7B%22status%22%3A%5B%22CONFIRMED%22%2C%22ATPICKUPPOINT%22%2C%22ATDELIVERYPOINT%22%2C%22INTRANSIT%22%2C%22TOBERETURNED%22%2C%22INCIDENCE%22%5D%2C%22shipping-updated-at%22%3A%7B%22startDate%22%3A%22' + utcGeneralStalledDateFrom.utc().toDate() + '%22%2C%22endDate%22%3A%22' + utcGeneralStalledDateTo.utc().toDate() + '%22%2C%22dateRangeActive%22%3Atrue%7D%7D'" v-translate>General Stalled</b-link></h6>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'SummaryPanelComponent',
  components: {
    DateRangePicker
  },
  data() {
    return {
      summary: [],
      totals: {},
      utcDateFrom: null,
      utcDateTo: null,
      date_from: this.moment().subtract(6, 'day').startOf('day'),
      date_to: this.moment().subtract(0, 'day').endOf('day'),
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().subtract(6, 'day').toDate(),
        endDate: this.moment().toDate()
      },
      opens: 'right',
      locale: {
        direction: 'ltr',
        format: this.$gettext('mm/dd/yyyy'),
        separator: ' - ',
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(),
        monthNames: this.moment.monthsShort(),
        firstDay: 1,
        showWeekNumbers: false
      },
      ranges: {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().toDate()],
        [this.$gettext('Last 120 days')]: [this.moment().subtract(119, 'day').toDate(), this.moment().toDate()]
      },
      updatedDateRangeActive: 0,
      minDate: '',
      maxDate: this.moment().toDate(),
      workedCouriers: 0,
      generalStalled: null,
      utcGeneralStalledDateFrom: null,
      utcGeneralStalledDateTo: null
    }
  },
  watch: {
    updatedDateRangeActive: {
      handler (val) {
        if (val !== 0) {
          this.date_from = this.moment(this.updatedDateRange.startDate)
          this.date_to = this.moment(this.updatedDateRange.endDate)
        } else {
          this.date_from = this.moment().subtract(6, 'day')
          this.date_to = this.moment().subtract(0, 'day')
        }
        this.$emit('dateRangeUpdated', true)
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      this.getSummary()
      this.getGeneralStalled()
      this.fetchWorkingCouriers()
    },
    getGeneralStalled() {
      this.utcGeneralStalledDateFrom = this.moment().tz(this.$tz).clone().subtract(15, 'day').startOf('day')
      this.utcGeneralStalledDateTo = this.moment().tz(this.$tz).clone().subtract(1, 'day').endOf('day')

      const params = {
        limit: 1,
        filter_groups: [
          {
            filters: [
              ['updated_at', 'bt', [this.utcGeneralStalledDateFrom.utc().format('YYYY-MM-DD HH:mm:ss'), this.utcGeneralStalledDateTo.utc().format('YYYY-MM-DD HH:mm:ss')]],
              ['status', 'in', ['CONFIRMED', 'ATPICKUPPOINT', 'INTRANSIT', 'ATDELIVERYPOINT', 'INCIDENCE', 'TOBERETURNED']],
              ['shipping_type_id', 'eq', this.flexesTypeId, 'true']
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings', { params })
        .then(response => {
          this.generalStalled = response.body.pagination.total
        })
    },
    fetchWorkingCouriers() {
      const params = {
        limit: 1,
        filter_groups: [
          {
            filters: [
              ['created_at', 'bt', [this.utcDateFrom.utc().format('YYYY-MM-DD HH:mm:ss'), this.utcDateTo.utc().format('YYYY-MM-DD HH:mm:ss')]]
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['user.country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/couriers/worked', { params })
        .then(response => {
          this.workedCouriers = response.body.pagination.total
        })
    },
    getSummary() {
      this.utcDateFrom = this.date_from.tz(this.$tz).startOf('day').clone()
      this.utcDateTo = this.date_to.tz(this.$tz).endOf('day').clone()

      const params = {
        date_to: this.utcDateTo.utc().format('YYYY-MM-DD'),
        time_to: this.utcDateTo.utc().format('HH:mm:ss'),
        date_from: this.utcDateFrom.utc().format('YYYY-MM-DD'),
        time_from: this.utcDateFrom.utc().format('HH:mm:ss'),
        filter_by: 'updated_at'
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.from_country_iso_code = window.country
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings/summarize', { params })
        .then(response => {
          this.summary = response.body

          const statuses = [
            'DRAFT',
            'READY',
            'CONFIRMED',
            'ATPICKUPPOINT',
            'INTRANSIT',
            'ATDELIVERYPOINT',
            'DELIVERED',
            'INCIDENCE',
            'TOBERETURNED',
            'RETURNED',
            'CANCELED'
          ]

          for (const status of statuses) {
            this.totals[status] = this.summary.reduce((total, obj) => (obj.statuses[status] || 0) + total, 0)
          }
        })
      this.minDate = this.moment(JSON.parse(JSON.stringify(this.date_from))).subtract(120, 'days').toDate()
    },
    makeLink(status, companyIds, names) {
      const qf = {
        status,
        'shipping-updated-at': {
          startDate: this.date_from.clone().startOf('day').format('YYYY-MM-DD'),
          endDate: this.date_to.clone().endOf('day').format('YYYY-MM-DD'),
          dateRangeActive: true
        }
      }
      if (companyIds) {
        qf['shipping-company'] = companyIds.map((id, i) => {
          return {
            id,
            name: names[i]
          }
        })
      }
      return encodeURIComponent(JSON.stringify(qf))
    },
    resetupdatedDateRange() {
      this.updatedDateRange = {
        startDate: this.moment().subtract(6, 'day').toDate(),
        endDate: this.moment().toDate()
      }
      this.updatedDateRangeActive = 0
    },
    updateValues(obj) {
      this.updatedDateRangeActive++
    }
  }
}
</script>
